module.exports = __webpack_public_path__ + "static/media/Polygon1001.454dc0cf.svg";